import axios from "axios";

// Isolated client so the app JWT interceptor cannot overwrite Authorization.
const externalClient = axios.create();

const EXTERNAL_API_BASE =
  process.env.REACT_APP_EXTERNAL_API_URL
  || (process.env.NODE_ENV === "production"
    ? "https://api.weave.md"
    : "http://localhost:8001");

export function getExternalApiBaseUrl() {
  return EXTERNAL_API_BASE.replace(/\/$/, "");
}

/** @deprecated Prefer getExternalApiBaseUrl */
export const getExternalApiBase = getExternalApiBaseUrl;

export function buildExternalRequestUrl({ path, query = {} }) {
  const url = new URL(path.startsWith("http") ? path : `${getExternalApiBaseUrl()}${path}`);
  Object.entries(query || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      url.searchParams.set(key, value);
    }
  });
  return url.toString();
}

export function runExternalApiRequest({ method, path, apiKey, token, query = {}, body = null }) {
  const key = apiKey || token;
  const url = buildExternalRequestUrl({ path, query });
  return externalClient({
    method: (method || "GET").toLowerCase(),
    url,
    headers: {
      Authorization: `Bearer ${key}`,
      "Content-Type": "application/json",
    },
    data: body && method && method.toUpperCase() !== "GET" ? body : undefined,
    validateStatus: () => true,
  });
}

/** POSIX-safe single-quoted shell string. */
function shellSingleQuote(value) {
  return `'${String(value).replace(/'/g, `'\\''`)}'`;
}

export function buildSnippet({ mode, method, url, apiKey, body }) {
  const m = (method || "GET").toUpperCase();
  if (mode === "curl") {
    const bodyPart =
      body && m !== "GET"
        ? ` \\\n  -H "Content-Type: application/json" \\\n  -d ${shellSingleQuote(JSON.stringify(body))}`
        : "";
    return `curl -X ${m} "${url}" \\\n  -H "Authorization: Bearer ${apiKey}"${bodyPart}`;
  }
  if (mode === "python") {
    // json.loads so false/true/null stay valid Python (JSON.stringify alone is not).
    const bodyLine =
      body && m !== "GET"
        ? `,\n    json=json.loads(${JSON.stringify(JSON.stringify(body))})`
        : "";
    return `import json\nimport requests\n\nresponse = requests.request(\n    "${m}",\n    "${url}",\n    headers={"Authorization": "Bearer ${apiKey}"}${bodyLine}\n)\nprint(response.status_code)\nprint(response.json())`;
  }
  const bodyLine =
    body && m !== "GET" ? `,\n  body: JSON.stringify(${JSON.stringify(body)})` : "";
  return `const response = await fetch("${url}", {\n  method: "${m}",\n  headers: {\n    Authorization: "Bearer ${apiKey}",\n    "Content-Type": "application/json",\n  }${bodyLine}\n});\nconst data = await response.json();\nconsole.log(response.status, data);`;
}
